<template>
  <div class="modal-background">
    <div class="modal-container">
      <div class="modal-content">
        <div class="content-img">
          <img :src="popup.imgPath" alt="팝업 이미지" class="cursor" @click="onClickPopup" />
        </div>
      </div>
      <div class="modal-footer">
        <div class="text-wrap">
          <input type="checkbox" v-model="todayCheck" class="checkbox" />
          <span class="is-14r">오늘 하루 보지 않기</span>
        </div>
        <div class="close-btn" @click="close">닫기</div>
      </div>
    </div>
  </div>
</template>

<script>
import {useCookie} from '#app'

export default {
  name: 'PopupModal',
  props: {
    popup: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      todayCheck: false
    }
  },
  methods: {
    onClickPopup() {
      if (this.popup.link) {
        window.open(this.popup.link, '_blank')
      }
    },
    close() {
      if (this.todayCheck) {
        const popupCookie = useCookie('popupBlock', {maxAge: 60 * 60 * 24})
        popupCookie.value = 'Y'
      }
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.modal-background {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #0f0f0f80;
  z-index: 100;
}

.modal-container {
  //width: 420px;
  //min-height: 320px;
  max-height: calc(100% - 64px);
  background: #ffffff;
  overflow: auto;

  .modal-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  .modal-content {
    overflow: auto;

    .is-14r {
      margin-bottom: 16px;
      white-space: pre-line;
    }
  }

  .modal-footer {
    display: flex;
    padding: 10px;

    .text-wrap {
      display: flex;
      align-items: center;
      gap: 8px;

      .checkbox {
        appearance: none;
        width: 18px;
        height: 18px;
        border: 1px solid #dbdbdb;
        border-radius: 4px;
        cursor: pointer;
        position: relative;

        &:checked {
          background-color: #4a90e2;
          border-color: #4a90e2;

          &::after {
            content: '✔';
            font-size: 14px;
            color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }

      .is-14r {
        font-size: 14px;
        font-weight: 400;
      }
    }

    .close-btn {
      margin-left: auto;
      cursor: pointer;
      padding: 4px 8px;
      font-size: 14px;
      font-weight: 500;
      color: #606060;
      border: 1px solid #dbdbdb;
      border-radius: 4px;
    }
  }
}
</style>
